import { Typography,Link} from '@mui/material'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import api from 'api'
import { AuthStateContext } from 'context/auth'
import { makeSubscribable } from 'helpers'


const ResendCodeMessage = ({resendCode}) => {
  const [authState] = useContext(AuthStateContext)
  const { email } = authState
  const [loading, setLoading] = useState(false)
  const [subscribable, setSubscribable] = useState(null)

  const onResendCodeClick = useCallback(async () => {
    if (email) {
      const promise = api.resendSignUp(email.toLowerCase())
      const subscribable = makeSubscribable(promise)

      setSubscribable(subscribable)
    }
  }, [email])

  const onSuccess = useCallback(() => {
    setLoading(false)
  }, [])

  const onError = useCallback(() => {
    setLoading(false)
    // TODO: what to do?
  }, [])

  useEffect(() => {
    if (subscribable) {
      setLoading(true)
      return subscribable.subscribe(onSuccess, onError)
    }
  }, [onError, onSuccess, subscribable])
  useEffect(() => {
    resendCode && onResendCodeClick()
  },[resendCode,onResendCodeClick])

  return (
    <Typography sx={{fontSize:'14px'}}>
      Didn’t receive your code? Please refresh your email inbox, check spam and junk folders, or{' '}
      <Link onClick={onResendCodeClick} underline="hover" sx={{color: '#0A78CD',  fontWeight: '700', fontSize: '14px', fontFamily: 'poppins', textTransform: 'capitalize', textDecoration: 'none', cursor: 'pointer'}}>
        {loading ? 'Sending...' : 'click here'}
      </Link>{' '}
      to send a new confirmation code.
    </Typography>
  )
}

export default ResendCodeMessage
